

import {
    Component,
    OnInit,
  } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { arrayUnion, updateDoc } from "firebase/firestore";
  import { NGXLogger } from "ngx-logger";
  import { MenuItem, MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { PreventivoFase1DTO } from "src/app/models/dto/preventivoFase1.model";
import { SopralluogoFase1DTO } from "src/app/models/dto/sopralluogoFase1.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { PraticheScuolaService } from "src/app/services/pratiche.scuola.service";
import { PraticheService } from "src/app/services/pratiche.service";
import { environment } from "src/environments/environment";

  

@Component({
    selector: "component-carica-pacchetto-nt9",
    templateUrl: "./dialog-carica_pacchetto_nt9.component.html",
    styleUrls: ["../shared.component.css"],
  })
  export class DialogCaricaPacchettoNT9 implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected pratica: PraticaFlowdy2_Firestore;
    protected tipoFile:String="";
    
    protected file: File;
    protected files: File[]=[];
    protected isUploadingFile:boolean = false;
    
    protected label:string="Cerca pacchetto NT9";
    protected icona:string="";
    protected stile:string="btn-choose-file-fase2";
    protected fileClass:string="btn-choose-file-fase2";
    protected acceptedFileTypes:string=".zip";

    private collection_pratiche:string = environment.firebase.collection_pratiche;


    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private googleStorageService: GoogleStorageService,
      private messageService: MessageService,
      private formBuilder: FormBuilder,
      public firestore: AngularFirestore,
    ) {
      this.pratica          = this.config.data.pratica;      

    }
  
    ngOnInit(): void {
    }

    onFileUpload($event){

    }

    onFileSelect($event: { files: File[]; }) {
      this.label = 'Pacchetto NT9 caricato';
     
     
      this.icona = "pi pi-check";
      this.fileClass = "btn-file-fase2-upload-success";
      this.file = $event.files[0];
      this.files = Array.from($event.files); 
    }  

   
    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {

          this.isUploadingFile = true;
          
          const fileUploadPromises: Promise<any>[] = [];

          for (let index = 0; index < this.files.length; index++) {
            const file = this.files[index];
            const fileExtension = file.name.substring( file.name.lastIndexOf(".") + 1 );
            let fileName        = this.pratica.cui + "/IN/FASE_3/file/nt9.zip";
            const fileUploadPromise = this.googleStorageService.uploadFileScuolaToGoogleStorage(this.file, fileName);
            fileUploadPromises.push(fileUploadPromise);
          }
         
          Promise.all(fileUploadPromises).then(results => {
            const docRef = this.firestore.collection(this.collection_pratiche).doc(this.pratica.cui);
            this.pratica.nt9Uploaded = true;
           
            docRef.update(this.pratica)
              .then(() => {
                
                this.isUploadingFile = false;
                this.dialogRef.close({ success: true});
              })
              .catch((error) => {
                this.messageService.add({
                  severity: "info",
                  summary: "Errore" , life:10000,
                    detail: "Errore in fase di caricamento del pacchetto NT9!",
                  });
                
                this.dialogRef.close({ success: false });
              });
          }).catch(error => {
            this.dialogRef.close({ success: false });
          }).finally(() => {
            this.isUploadingFile = false;
          });
         
       
      } 
    }
  
  }